import getPopoutUrlKey from './getPopoutUrlKey.js';

const getPopoutUrl = async name =>
  localStorage.getItem(getPopoutUrlKey(name));

export default getPopoutUrl;